import { useQuery } from '@tanstack/react-query';
import { memo } from 'react';

import { Skeleton } from '@doger/ui/components/ui/skeleton';
import { $$api, ErrorMatcher } from '@doger/core/shared/api';

import { ChatListItem } from './chat-list-item.component';
import styles from './chat-list.module.scss';

type ChatListProps = {
  onChatClick: (chatId: string) => void;
};

const ChatList = memo(({ onChatClick }: ChatListProps) => {
  const { data: sessions = [], isLoading } = useQuery({
    queryKey: ['auth', 'sessions'],
    queryFn: () =>
      $$api.listSessions().catch((error) => {
        if (
          ErrorMatcher.isAppError(error, [
            'NOT_ON_WHITELIST',
            'EMAIL_NOT_CONFIRMED',
            'COMPLETED_PROFILE_REQUIRED',
          ])
        ) {
          return [];
        }

        throw error;
      }),
  });

  if (isLoading) {
    return (
      <div className={styles.chatList__container}>
        <Skeleton className={styles.chatList__skeleton} />
        <Skeleton className={styles.chatList__skeleton} />
        <Skeleton className={styles.chatList__skeleton} />
      </div>
    );
  }

  return (
    <div className={styles.chatList__container}>
      {sessions.map((session) => (
        <ChatListItem
          key={session.id}
          session={session}
          onChatClick={onChatClick}
        />
      ))}
    </div>
  );
});

export { ChatList };
